// ----------------------------------------------------------------------
// <copyright file="Izenda.GridItemState.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!function () {
  var action = require('mobx').action;
  var extendObservable = require('mobx').extendObservable;


  /**
   * Represent an observable grid layout item
   * @param {String}  id            Grid item identity
   * @param {Number}  gridLeft      Grid item left position
   * @param {Number}  gridTop       Grid item top position
   * @param {Number}  gridWidth     Grid item width
   * @param {Number}  gridHeight    Grid item height
   * @param {Boolean} isFullSize    Grid item is showing full size of its container.
   * @param {Boolean} autoSize      Grid item determine its size by itself, not by user design.
   */
  function GridItemState (
    id,
    gridLeft,
    gridTop,
    gridWidth,
    gridHeight,
    isFullSize,
    autoSize,
    isLoading
  ) {

    this.id = id;
    this.autoSize = autoSize;
    this.isLoading = isLoading;

    extendObservable(this, {
      // Left position in grid coordination
      gridLeft: gridLeft,
      // Top position in grid coordination
      gridTop: gridTop,
      // Width in grid coordination
      gridWidth: gridWidth,
      // Height in grid coordination
      gridHeight: gridHeight,
      // Actual top pixel in relative with grid view
      pxTop: 0,
      // Actual left pixel in relative with grid view
      pxLeft: 0,
      // Actual width pixel in relative with grid view
      pxWidth: 0,
      // Actual height pixel in relative with grid view
      pxHeight: 0,
      // Need to show the item in full grid view
      isFullSize: isFullSize,
      // Determine the grid item is moving
      isMoving: false,
      // Determine the grid item is resizing
      isResizing: false,
      // Determine the grid item is interacting by user
      isInteracting: function () {
        return this.isResizing || this.isMoving;
      },
      // Determine the grid item needs to be animated, normally
      // happens after user commit their changes (size, position)
      needAnimation: false
    });
  }
  /**
   * Moving grid item
   */
  GridItemState.prototype.moving = action(function moving (isMoving) {
    this.isMoving = isMoving;
  });
  /**
   * Resizing grid item
   */
  GridItemState.prototype.resizing = action(function resizing (isResizing) {
    this.isResizing = isResizing;
  });
  /**
   * Animating grid item
   */
  GridItemState.prototype.animating = action(function animating (isAnimating) {
    this.needAnimation = isAnimating;
  });

  GridItemState.prototype.getPxPosition = function () {
    return {
      top : this.pxTop,
      left : this.pxLeft,
      width : this.pxWidth,
      height : this.pxHeight
    };
  };

  /**
   * Update the pixel position of grid item
   */
  GridItemState.prototype.updatePosition = action(function updatePosition (position) {
    this.pxTop = position.top;
    this.pxLeft = position.left;

    (!this.autoSize || this.pxWidth === 0) && (this.pxWidth = position.width);
    (!this.autoSize || this.pxHeight === 0) && (this.pxHeight = position.height);
  });

  /**
   * Update grid-coordination position of grid item
   */
  GridItemState.prototype.updateGridPosition = action(function updateGridPosition (gridPosition) {
    this.gridTop = gridPosition.top;
    this.gridLeft = gridPosition.left;
    this.gridWidth = gridPosition.width;
    this.gridHeight = gridPosition.height;
  });

  GridItemState.prototype.updateActualSize = action(function updateActualSize (pxWidth, pxHeight) {
    this.pxWidth = pxWidth;
    this.pxHeight = pxHeight;
  });

  /**
   * Update data of grid item
   */
  GridItemState.prototype.copy = action(function updateItem (layoutItem) {
    // Indicate that needs to animate the layout changes.
    this.animating(isItemChanged(this, layoutItem));

    // Update changed values to grid item
    this.isFullSize = layoutItem.isFullSize;
    this.autoSize = layoutItem.autoSize;
    this.gridLeft = layoutItem.gridLeft;
    this.gridTop = layoutItem.gridTop;
    this.gridWidth = layoutItem.gridWidth;
    this.gridHeight = layoutItem.gridHeight;
    this.isLoading = layoutItem.isLoading;
  });

  GridItemState.prototype.clone = function () {
    return {
      id: this.id,
      isFullSize : this.isFullSize,
      autoSize : this.autoSize,
      gridLeft : this.gridLeft,
      gridTop : this.gridTop,
      gridWidth : this.gridWidth,
      gridHeight : this.gridHeight,
      pxTop : this.pxTop,
      pxLeft : this.pxLeft,
      pxWidth : this.pxWidth,
      pxHeight : this.pxHeight,
      isLoading: this.isLoading
    };
  };

  /**
   * Detect grid item state changed
   */
  function isItemChanged (oldItem, newItem){
    return oldItem.gridLeft !== newItem.gridLeft
      || oldItem.gridTop !== newItem.gridTop
      || oldItem.gridWidth !== newItem.gridWidth
      || oldItem.gridHeight !== newItem.gridHeight
      || oldItem.isFullSize !== newItem.isFullSize
      || oldItem.autoSize !== newItem.autoSize;
  }

  module.exports = GridItemState;
}();



// WEBPACK FOOTER //
// ./ui/share/components/controls/GridLayout/Izenda.GridItemState.js